import { useQuery } from '@tanstack/react-query';
import { HTTPError } from 'ky';
import { useRouter } from 'next/router';
import { Loop54Types } from '~/lib/data-contract';
import { GetRecentEntitiesRequest } from '~/lib/data-contract/auto-generated/loop54-api-model';
import { getRecentEntities } from '~/services/loop54/operations';

type Response = Loop54Types.GetEntitiesResponse;

export default function useRecentEntities<SelectType = Response>(
    params: GetRecentEntitiesRequest,
    select?: (data: Response) => SelectType,
) {
    const router = useRouter();

    return useQuery<Response, HTTPError | Error, SelectType>(
        ['recentEntities', router.asPath, params],
        ({ signal }) => getRecentEntities(signal, params),
        {
            enabled: !!params,
            select,
            retry: 1,
            cacheTime: 0, // Disable cache so that we get personalized result every time page is requested
            staleTime: 0, // Disable stale time so that we get personalized result every time page is requested
        },
    );
}
